import React, { Component } from 'react';
import PropTypes from 'prop-types';

class ModalManager extends Component {
  render () {
    const { children, whichModal, ...props } = this.props;
    const childrenWithProps = React.Children.map(children, (child) => {
      return child && React.cloneElement(child, {
        showModal: whichModal === child.props.id,
        ...props
      });
    });
    return (
      whichModal ?
        <div>
          { childrenWithProps }
        </div> : null
    );
  }
}

ModalManager.propTypes = {
  children: PropTypes.array,
  whichModal: PropTypes.string
};

export default ModalManager;
